import Immutable from 'immutable';
import { DocId } from 'records/Doc';
import { ProjectId } from 'records/Project';

export type PageId = string;

export interface RawPage {
  pageid: PageId;
  documentid: DocId;
  projectid: ProjectId;
  width: number;
  height: number;
  rendered: string;
  spacesExtracted: string;
  markupsExtracted: string;
  uploader: string;
  uploadTimestamp: number;
  processingRequestid: string;
  documentTitle: string;
  pageLabel: string;
  pageIndex: number;
  reviewedTimestamp: number;
  reviewer: string;
  thumbnailUrl: string; // added by web client, not part of the GraphQL schema.
}

export interface PageData {
  pageid: PageId;
  documentid: DocId;
  projectid: ProjectId;
  width: number;
  height: number;
  rendered: string;
  spacesExtracted: string;
  markupsExtracted: string;
  uploader: string;
  uploadTimestamp: number;
  processingRequestid: string;
  documentTitle: string;
  pageLabel: string;
  pageIndex: number;
  reviewedTimestamp: number;
  reviewer: string;
  thumbnailUrl: string;
}

const defaultValues: PageData = {
  pageid: '',
  documentid: '',
  projectid: '',
  width: 0,
  height: 0,
  rendered: 'false',
  spacesExtracted: 'false',
  markupsExtracted: 'false',
  uploader: '',
  uploadTimestamp: 0,
  processingRequestid: '',
  documentTitle: '',
  pageLabel: '',
  pageIndex: 0,
  reviewedTimestamp: 0,
  reviewer: '',
  thumbnailUrl: '',
};

export const PageFactory = Immutable.Record(defaultValues, 'Page');

export class Page extends PageFactory {
  static deserialize(rawPage: RawPage): Page {
    return new Page({
      ...rawPage,
    });
  }

  serialize(): RawPage {
    return this.toJS();
  }
}

export type PageList = Immutable.List<Page>;

export type PageMap = Immutable.OrderedMap<PageId, Page>;
